import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getMunicipalityEmployees = async (token, municipalityId) => {
  const url = `municipalities/${municipalityId}/employee_options`
  const data = await apiGet({ url, token })
  return data
}

export default function useMunicipalityEmployees({ options }) {
  const { municipality_id } = useContext(UserContext)
  const token = useContext(AuthContext)
  const queryFn = () => getMunicipalityEmployees(token, municipality_id)
  const queryKey = 'employee_options'
  return useQuery(queryKey, queryFn, { ...options })
}
